// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__17Aja","range":"MonthRangeSwitch_range__3VhKC","disabled":"MonthRangeSwitch_disabled__43Mu3"};